import { ModuleDTO } from 'src/models/dto/ModuleDTO'
import { downloadAsFile } from 'src/services/downloadAsFile'

export const CONTAINER_COLUMN = '__container__'

const PLACEHOLDER_REGEX = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g

export function extractPlaceholders(module: ModuleDTO): string[] {
    const json = JSON.stringify(module)
    const found = new Set<string>()
    let match: RegExpExecArray | null
    while ((match = PLACEHOLDER_REGEX.exec(json)) !== null) {
        found.add(match[1])
    }
    PLACEHOLDER_REGEX.lastIndex = 0
    return Array.from(found)
}

export function getSpreadsheetColumns(module: ModuleDTO): string[] {
    const extracted = extractPlaceholders(module)
    return extracted.includes(CONTAINER_COLUMN) ? extracted : [...extracted, CONTAINER_COLUMN]
}

export function downloadSampleSpreadsheet(columns: string[], moduleName?: string) {
    downloadAsFile(
        new Blob([`${columns.join(',')}\n`], { type: 'text/csv' }),
        `${moduleName ?? 'import'}_sample.csv`
    )
}
